<template>
  <div class="yunxiao teacher comment-reply-add">
    <div class="main-section">
      <van-form>
        <van-field
          size="large"
          v-model="title"
          type="text"
          required
          maxlength="20"
          placeholder="请输入名称，20个字以内"
          label="回评问卷名称"
          input-align="right"
          class="first-line"
        ></van-field>
        <div class="split">维度</div>

        <div class="option-wrapper">
          <div class="option-item van-hairline--bottom" v-for="(item, index) in list" :key="index">
            <div @click="deleteDimensionItem(index)">
              <van-icon
                class-prefix="vxs-icon"
                name="system_del"
                color="var(--c3)"
              />
            </div>
            <div class="option-name">
              <van-field
                v-model="item.title"
                placeholder="请输入维度名称，20个字以内"
                maxlength="20"
                :formatter="v => v.trimLeft()"
              />
            </div>
            <div class="option-btn">
              <span>
                <svg
                  class="vxm-icon"
                  aria-hidden="true"
                  @click="addOrder(index)"
                  v-if="index !== 0"
                >
                  <use xlink:href="#vxm-icon-system_up"></use>
                </svg>
              </span>
              <span>
                <svg
                  class="vxm-icon"
                  aria-hidden="true"
                  @click="reduceOrder(index)"
                  v-if="index !== list.length - 1"
                >
                  <use xlink:href="#vxm-icon-system_down"></use>
                </svg>
              </span>
            </div>
          </div>
        </div>

        <div class="add-dimension" @click="addDimensionItem" v-if="list.length < 10">
          <van-icon
            class-prefix="vxs-icon"
            name="system_add"
            color="var(--c1)"
            style="margin-right: 6px"
          />新增维度
        </div>
      </van-form>
    </div>
    <pageFooterBtn @click="submit" :loading="submiting" btnText="确定" loading-text="提交中..." />
  </div>
</template>

<script>
import pageFooterBtn from '@x3/vue/comp/page-footer-btn.vue';

export default {
  name: 'comment-reply-add',
  components: {
    pageFooterBtn,
  },
  data() {
    return {
      pageTitle: '添加回评问卷',
      list: [],
      title: '',
      submiting: false,
    };
  },
  created() {},
  methods: {
    submit() {
      if (this.title.trim() == '') {
        this.$toast.fail('请输入回评问卷名称');
        return;
      }

      if (this.list.length == 0) {
        this.$toast.fail('请至少添加一个维度');
        return;
      }
      if (this.list.some(item => item.title.trim() === '')) {
        this.$toast.fail('维度名为空，请输入维度名');
        return;
      }

      this.showLoading();
      let params = {
        questions: this.list.map((item, index) => ({
          title: item.title,
          type: 1,
          sort: index,
        })),
        title: this.title,        
      };
      this.$api
        .editQanda(params)
        .then(res => {
          this.$toast.success('新增成功');          
          app.vue.$emit('comment-reply-list-refresh');
          this.$router.back();
          vant.Toast.clear();
        })
    },
    addOrder(index) {
      this.list[index] = this.list.splice(index - 1, 1, this.list[index])[0];
    },
    reduceOrder(index) {
      this.list[index] = this.list.splice(index + 1, 1, this.list[index])[0];
    },
    addDimensionItem() {
      this.list.push({ title: '' });
    },
    deleteDimensionItem(index) {
      if (this.list.length === 1) {
        return;
      }
      this.list.splice(index, 1)[0];
    },
  },
  beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
.yunxiao.teacher.comment-reply-add {
  display: flex;
  flex-direction: column;
  .main-section {
    padding-bottom: calc(var(--gap) * 12);
    flex: 1;
    overflow-y: auto;
    .g5 {
      color: var(--g5);
    }
    .split {
      padding: calc(var(--gap) * 8) calc(var(--gap) * 16);
      font-size: var(--fs-md);
      line-height: var(--lh-md);
      color: var(--g6);
      background: var(--g1);
    }
    .add-dimension {
      padding: calc(var(--gap) * 16);
      color: var(--c1);
      background-color: var(--white);
    }
    .option-wrapper {
      padding: 0 calc(var(--gap) * 16);
      background-color: var(--white);
      .option-item {
        display: flex;
        align-items: center;
        font-size: var(--fs-md);
        line-height: var(--lh-md);
        box-sizing: content-box;
        .option-name {
          flex: 1;
        }
        .option-btn {
          font-size: 24px;
          & > span {
            display: inline-block;
            width: 24px;
            height: 24px;
            margin-left: calc(var(--gap) * 8);
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
.yunxiao.teacher.comment-reply-add {
  .first-line::after {
    display: none;
  }
}
</style>